// extracted by mini-css-extract-plugin
module.exports = {"headerInfoContainer":"HeaderInfo_headerInfoContainer__1yKkT","category":"HeaderInfo_category__2s-Ja","links":"HeaderInfo_links__3rinI"};